import React from "react";
import ReactDOM from "react-dom";
import { ErrorBodyComponent } from "./components/ErrorBody/ErrorBodyComponent";

const errorBody = document.getElementById("errorBody");
if (errorBody) {
  ReactDOM.render(
    <ErrorBodyComponent
      baseUrl={window["BaseUrl"]}
      cdnBasePath={window["CdnBasePath"]}
      year={window["Year"]}
      errorMessage={window["ErrorMessage"]}
      errorLinkMessage={window["ErrorLinkMessage"]}
    />,
    errorBody
  );
}
